import { tableHeaderStyles } from "./tableStyles";
import { createTheme } from '@mui/material/styles';

const adminTheme = createTheme({
  palette: {
    primary: { main: '#245c50', dark: '#174337', light: '#e8f3ef' },
    secondary: { main: '#51618a' },
    background: { default: '#f4f6f8', paper: '#ffffff' },
    text: { primary: '#182b36', secondary: '#586975' },
    divider: '#e3e9ed',
    success: { main: '#24734d' }, warning: { main: '#946000' },
    error: { main: '#bf3545' }, info: { main: '#276b9c' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h4: { fontSize: '1.8rem', fontWeight: 750, letterSpacing: '-0.04em' },
    h5: { fontSize: '1.4rem', fontWeight: 700, letterSpacing: '-0.025em' },
    h6: { fontSize: '1.05rem', fontWeight: 650 },
    button: { textTransform: 'none', fontWeight: 650 },
    body2: { lineHeight: 1.6 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { minHeight: 40, paddingInline: 18 } } },
    MuiIconButton: { styleOverrides: { root: { minWidth: 40, minHeight: 40 } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' }, rounded: { border: '1px solid #e3e9ed' }, elevation1: { boxShadow: '0 2px 8px #182b3606' }, elevation3: { boxShadow: '0 4px 20px #182b3608' } } },
    MuiTextField: { defaultProps: { size: "small" } },
    MuiFormControl: { defaultProps: { size: "small" } },
    MuiOutlinedInput: { styleOverrides: { root: { backgroundColor: '#fff' }, notchedOutline: { borderColor: '#cbd5dc' } } },
    MuiFormHelperText: { styleOverrides: { root: { marginLeft: 0, lineHeight: 1.5 } } },
    MuiTableContainer: { styleOverrides: { root: { maxWidth: '100%', overflowX: 'auto' } } },
    MuiTableCell: { styleOverrides: { root: { borderColor: '#e8edf1', padding: '14px 16px' }, head: { ...tableHeaderStyles, fontWeight: 700, whiteSpace: 'nowrap', fontSize: '0.75rem' } } },
    MuiTableRow: { styleOverrides: { root: { '&:last-child td': { borderBottom: 0 }, '&:hover td': { backgroundColor: '#245c5005' } } } },
    MuiTablePagination: { styleOverrides: { toolbar: { flexWrap: 'wrap', paddingBlock: 8, gap: 4 }, spacer: { flex: '1 1 0' }, selectLabel: { margin: 0 }, displayedRows: { margin: 0 } } },
    MuiTabs: { defaultProps: { variant: 'scrollable', scrollButtons: 'auto', allowScrollButtonsMobile: true }, styleOverrides: { root: { minHeight: 48, borderBottom: '1px solid #e3e9ed' } } },
    MuiTab: { styleOverrides: { root: { textTransform: 'none', fontWeight: 650, minHeight: 48 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 650, borderRadius: 6 } } },
    MuiDialog: { defaultProps: { fullWidth: true, maxWidth: 'sm' }, styleOverrides: { paper: { borderRadius: 16, margin: 16, width: 'calc(100% - 32px)' } } },
    MuiDialogTitle: { styleOverrides: { root: { padding: '24px 24px 16px' } } },
    MuiDialogActions: { styleOverrides: { root: { padding: '16px 24px', gap: 8, flexWrap: 'wrap', borderTop: '1px solid #e3e9ed' } } },
    MuiAlert: { styleOverrides: { root: { borderRadius: 10, alignItems: 'center' } } },
    MuiDataGrid: { styleOverrides: { root: { borderColor: '#e3e9ed', backgroundColor: '#fff', '--DataGrid-containerBackground': tableHeaderStyles.backgroundColor }, columnHeaders: { ...tableHeaderStyles }, columnHeader: { ...tableHeaderStyles }, columnHeaderTitle: { fontWeight: 700 }, cell: { borderColor: '#e8edf1' } } },
  },
});
export default adminTheme;
